// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__Za4Xy","icon_spec":"Icon_icon_spec__8U9h-"};